"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _jsx2 = _interopRequireDefault(require("@babel/runtime/helpers/jsx"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _omit2 = _interopRequireDefault(require("lodash/omit"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _analyticsUtils = require("./analyticsUtils");

var _reactRedux = require("react-redux");

var _analyticsDefaultProperties = require("./analyticsDefaultProperties");

var _analyticsActions = require("./analyticsActions");

var _analyticsContext = _interopRequireDefault(require("./analyticsContext"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var mapDispatchToProps = {
  sendTrackEvent: _analyticsActions.sendTrackEvent
};

var analyticsEnhance = function analyticsEnhance() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (ComposedComponent) {
    var rules = (0, _analyticsUtils.expandRules)(options.ruleset);

    var AnalyticsEnhanceWrapper = function AnalyticsEnhanceWrapper(props) {
      var filteredProps = (0, _omit2.default)(props, ['sendTrackEvent']);

      var track = function track(e, analyticsValues) {
        var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
        var extraProps = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

        if (typeof window === 'undefined' && typeof window.analytics === 'undefined') {
          /* eslint no-console:0 */
          console.warn('Analytics not loaded - tracking event not completed');
          return;
        }

        props.sendTrackEvent(e, analyticsValues, callback, window.analytics.track, function () {}, function (state) {
          return _objectSpread(_objectSpread({}, state), extraProps);
        });
      };

      (0, _react.useEffect)(function () {
        if (typeof (rules || {}).page !== 'undefined' && !(0, _isEmpty2.default)(rules.page)) {
          setTimeout(function () {
            props.sendTrackEvent(window || {}, rules.page, function () {}, window.analytics.page, function (state) {
              return (0, _analyticsDefaultProperties.getDefaultPageProps)(state.config || {});
            });
          }, 1000);
        }
      }, []);
      return /*#__PURE__*/(0, _jsx2.default)(_analyticsContext.default.Provider, {
        value: {
          analyticsRules: rules,
          analyticsTrack: track
        }
      }, void 0, /*#__PURE__*/_react.default.createElement(ComposedComponent, filteredProps));
    };

    return (0, _reactRedux.connect)(function () {
      return {};
    }, mapDispatchToProps)(AnalyticsEnhanceWrapper);
  };
};

var _default = analyticsEnhance;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/common/analytics/analyticsEnhance.js
// module id = 3157
// module chunks = 25